import React from 'react';
import { FoldIcon, SharedFileEmptyIcon } from 'icons';
import { CADPanelWidth } from 'styles/constants';
import { EmptyText, SvgIcon } from 'components';
import { useCADManager } from 'hooks';
import { GoPlus } from 'react-icons/go';
import MeasureItem from '../measurements/measureItem';

export const MeasurementsPanel = () => {
  const { closePanel, viewerControl, sortedMeasurements } = useCADManager();

  const { viewer } = viewerControl;

  const { settings, notePad } = viewer || {};

  const handleClickNewMeasurement = () => {
    viewerControl.StartMeasureMode();
    viewerControl.SetActivePanel('');
  };

  const hasMeasurements = sortedMeasurements.length > 0;

  return (
    <div
      className='h-full'
      style={{
        width: CADPanelWidth,
      }}
    >
      <div className='flex px-4 my-2 w-full justify-between items-center'>
        <div className='flex-center'>
          <h2 className='text-sm text-wfBlack'>Measurements</h2>
          <p
            onClick={() => handleClickNewMeasurement()}
            className='ml-4 text-xs text-wfBlue cursor-pointer flex items-center'
          >
            New measurement <GoPlus className='ml-1' />
          </p>
        </div>

        <div
          data-testid='CADPage-closeMenu'
          className='flex-center cursor-pointer bg-wfGrey100 p-4 h-6 w-6 rounded-full z-[9999]'
          onClick={closePanel}
        >
          <SvgIcon icon={<FoldIcon />} style={{ width: 14, height: 14 }} />
        </div>
      </div>

      {hasMeasurements ? (
        <div className='flex flex-col h-full overflow-y-scroll'>
          {sortedMeasurements.map((measure, i) => {
            const isFirstMeasure = i === 0;

            return (
              <div
                key={`${measure.selfIx}_${measure.key}`}
                className={`w-full ${
                  isFirstMeasure ? 'border-y' : 'border-b'
                } border-wfGrey100 py-1 px-4`}
              >
                <MeasureItem measure={measure} />
              </div>
            );
          })}
        </div>
      ) : (
        <div className='flex-y-center w-full border-y border-wfGrey100  m-0 py-8 h-auto'>
          <SharedFileEmptyIcon />
          <EmptyText text='No measurements yet' />
        </div>
      )}
    </div>
  );
};
